import { render, staticRenderFns } from "./kaibaoProject.vue?vue&type=template&id=03b133b2&scoped=true&"
import script from "./kaibaoProject.vue?vue&type=script&lang=js&"
export * from "./kaibaoProject.vue?vue&type=script&lang=js&"
import style0 from "./kaibaoProject.vue?vue&type=style&index=0&id=03b133b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b133b2",
  null
  
)

export default component.exports